import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useForm } from 'react-hook-form';
import type { SubmitHandler } from 'react-hook-form';
import { Box, Button, Group, Image, Stack, Text } from '@mantine/core';
import { LogoBat } from '@/assets/login';
import { toast } from '@/components';
import { Form } from '@/components/form/form';
import { FormInputWrapper } from '@/components/form/form-input-wrapper';
import { LucideIcon } from '@/components/icons/LucideIcons';
import { env } from '@/consts';
import type { TokenRequest } from '@/services/token';
import { useLogin } from '@/services/token';
import { useAuthStore } from '@/stores/auth-store';

export const Route = createFileRoute('/(auth)/_auth/login')({
  component: RouteComponent,
});

function RouteComponent() {
  const { mutateAsync, isPending } = useLogin();
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const form = useForm<TokenRequest<'password'>>({
    defaultValues: {
      grant_type: 'password',
      client_id: env.client_id,
      client_secret: env.client_secret,
      username: '',
      password: '',
    },
  });

  const onSubmit: SubmitHandler<TokenRequest<'password'>> = async (payload) =>
    mutateAsync(payload)
      .then((data) => {
        login(data.data);
        navigate({ to: '/attendance' });
      })
      .catch(() => {
        toast.error({
          title: 'Gagal',
          message: 'Username atau Password salah!',
        });
      });

  return (
    <Box px={64} pos="relative" display="flex" h="70vh">
      <Group gap={8} pos="absolute">
        <Box h={42} w="auto">
          <Image src={LogoBat} />
        </Box>
        <Stack gap={2} justify="">
          <Text fw={700} fz={18} c="dark.5">
            Human Capital
          </Text>
          <Text c="gray" fz={14}>
            Information System
          </Text>
        </Stack>
      </Group>

      <Stack my="auto" w="100%">
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <Stack gap={8} mb={8}>
              <Text fz={28} fw={500}>
                Selamat Datang
              </Text>
              <Text fw={300} fz={16}>
                Masukkan username dan password untuk mengakses akun anda
              </Text>
            </Stack>
            <Stack gap={16}>
              <FormInputWrapper
                name="username"
                type="input"
                label="Username"
                inputProps={{
                  leftSection: <LucideIcon name="user" />,
                  placeholder: 'Masukkan username anda',
                }}
              />
              <FormInputWrapper
                name="password"
                type="password"
                label="Kata Sandi"
                inputProps={{
                  leftSection: <LucideIcon name="lock-keyhole" />,
                  placeholder: 'Masukkan kata sandi anda',
                }}
              />
              <Button w="fit-content" type="submit" loading={isPending} ml="auto">
                Masuk
              </Button>
            </Stack>
          </form>
        </Form>
      </Stack>
    </Box>
  );
}
